export default __webpack_public_path__ + "static/media/61.e7c7dfde.jpg";